import { Contract } from './contract';
import { ClientChat } from './contract';

export class CommunicationContractResponse {
  contracts: Array<Contract> = new Array<Contract>();
  unreadMessages: number;
  inactiveContracts: Array<Contract> = new Array<Contract>();
  activeContracts: Array<Contract> = new Array<Contract>();
  clientChat: ClientChat = new ClientChat();
}
